// 纸张（10-04 铃挑的六张 + 10-05 新找的六张，public/img/paper/*.webp）
// 日记「翻旧页」、记忆、时间点开都铺这些纸 —— 同一堆东西，打开是同一种纸。
// ar = 纸的宽高比；每张纸写字的留白在 Diary.css 的 .dr-leaf[data-paper=…] 里。
export const PAPER_AR = {
  sad: 0.5625, low: 0.4613, calm: 0.5628, soft: 0.5625, soft2: 0.5628, bright: 0.5629,
  sky: 0.4722, lily: 0.5636, sweet: 0.6662, bloom: 0.6228, vintage: 0.5668, stripe: 0.5664,
  astra: 0.5625, // 10-05 第 13 张：哥哥自己设计的「星图信纸」INTER · ASTRA · TECUM
};

// 换纸面板里的顺序 + 名字
export const PAPER_LIST = [
  ['astra', '星图'], ['calm', '平静'], ['soft', '柔光'], ['soft2', '柔光 II'], ['bright', '明亮'],
  ['sweet', '撕边信纸'], ['bloom', '花朵'], ['stripe', '条纹'], ['sky', '明信片'],
  ['lily', '百合'], ['vintage', '旧拼贴'], ['low', '低落'], ['sad', '难过'],
];

/* 她亲手给某一篇换的纸（10-05）：{ 条目id: 纸名 }，存 localStorage 并走云同步
   （lingke.paper.choice.v1 在 sync.js 的 SYNCED_KEYS 里）。没换过的照旧按心情挑。
   日记/记忆/时间里同一条是同一个 id → 在哪儿换都算数。 */
const CHOICE_KEY = 'lingke.paper.choice.v1';
function readChoices() {
  try {
    const v = JSON.parse(localStorage.getItem(CHOICE_KEY) || '{}');
    return v && typeof v === 'object' ? v : {};
  } catch {
    return {};
  }
}
export function chosenPaper(id) {
  const p = readChoices()[id];
  return p && PAPER_AR[p] ? p : null;
}
export function setChosenPaper(id, paper) {
  const all = readChoices();
  if (paper) all[id] = paper;
  else delete all[id];
  try {
    localStorage.setItem(CHOICE_KEY, JSON.stringify(all));
  } catch {
    /* 存不了就只这一次 */
  }
}

function hashOf(id) {
  let h = 0;
  for (const ch of String(id)) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  return h;
}
const pick = (list, id) => list[hashOf(id) % list.length];

// 一条记忆配哪张纸：按心情（valence/arousal），想念的话→蓝天明信片，很久以前的→旧纸。
// 同一条记忆每次打开都是同一张（按 id 固定挑）。
export function memoryPaper(b) {
  const v = typeof b.valence === 'number' ? b.valence : 0.5;
  const a = typeof b.arousal === 'number' ? b.arousal : 0.5;
  const id = b.bucket_id || b.id || b.title;
  if (v < 0.25) return 'sad';
  if (v < 0.4) return 'low';
  const text = `${b.title || ''} ${(b.tags || []).join(' ')} ${String(b.content || '').slice(0, 60)}`;
  if (/想你|想念|思念|好想/.test(text)) return 'sky';
  if (v >= 0.78 && a >= 0.55) return pick(['bright', 'sweet'], id);
  const t = Date.parse(b.created_at || '');
  const days = Number.isFinite(t) ? (Date.now() - t) / 86400000 : 0;
  if (v < 0.78 && days > 75) return pick(['lily', 'vintage'], id);
  if (v < 0.6) return pick(['calm', 'vintage', 'sky', 'astra'], id);
  return pick(['soft', 'soft2', 'bloom', 'stripe'], id);
}
